module.exports = __webpack_public_path__ + "img/曲线 1.a9a5b1d3.png";